import React, { Component } from 'react';
import { Result, Button } from 'antd';
import { logout } from './auth/authActions';
import { connect } from 'react-redux';
import Theme from './Theme';

class UserInactiveError extends Component {
  render() {
    return (
      <div style={{ overflow: 'auto', height: '100vh', width: '100vw' }}>
        <Theme />
        <Result
          status='403'
          title='Account Inactive'
          subTitle='Your account has been marked as inactive. Contact your Troopr administrator to regain access.'
          extra={
            <Button
              type='primary'
              onClick={() => {
                this.props.logout();
                window.location.href = '/troopr/access';
              }}
            >
              Sign In with a Different Account
            </Button>
          }
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button type='link' href='http://docs.troopr.ai' target='_blank'>
              Troopr Help Center
            </Button>
          </div>
        </Result>
      </div>
    );
  }
}

export default connect(null, {
  logout,
})(UserInactiveError);
